import { isAbortError } from '@app/errors/AbortError'
import { AppError } from '@app/errors/AppError'

import { captureException } from '@app/utils/errorReport/errorReport'
import { errorWhiteList } from '@app/utils/errorReport/errorWhitelist'

import { isNetworkFailError } from '@app/packages/api/errors'

export class ErrorReportController {
  report(e: unknown) {
    const err = this.errorForCapture(e)
    if (err) captureException(err)
  }

  errorForCapture(e: unknown) {
    if (!e) return null
    if (matchError(e, errorWhiteList)) return null
    if (isAbortError(e)) return null
    if (isNetworkFailError(e)) return null
    if (typeof e !== 'object') return e
    if (e instanceof AppError && e.handled) return null
    if ('status' in e && (e.status === 404 || e.status === 429)) return null
    if (e instanceof Error && 'handled' in e && e.handled) return null
    if (e instanceof Error) return e
    if ('message' in e && typeof e.message === 'string') {
      const err = new Error(e.message)
      err.cause = e
      return err
    }

    return e
  }
}

function matchError(error: object, regex: RegExp[]) {
  if (!error || typeof error !== 'object') return false
  if ('message' in error) {
    const message = error.message as string
    if (regex.find(error => error.test(message))) return true
  }
  if ('cause' in error && error.cause) return matchError(error.cause, regex)
  return false
}
